"use strict";

exports.__esModule = true;
exports.WHITE_SPACE = exports.ALIGN_V_OPTIONS = exports.ALIGN_OPTIONS = void 0;
let ALIGN_OPTIONS = /*#__PURE__*/function (ALIGN_OPTIONS) {
  ALIGN_OPTIONS["START"] = "start";
  ALIGN_OPTIONS["END"] = "end";
  ALIGN_OPTIONS["LEFT"] = "left";
  ALIGN_OPTIONS["CENTER"] = "center";
  ALIGN_OPTIONS["RIGHT"] = "right";
  return ALIGN_OPTIONS;
}({});
exports.ALIGN_OPTIONS = ALIGN_OPTIONS;
let ALIGN_V_OPTIONS = /*#__PURE__*/function (ALIGN_V_OPTIONS) {
  ALIGN_V_OPTIONS["BASELINE"] = "baseline";
  ALIGN_V_OPTIONS["SUB"] = "sub";
  ALIGN_V_OPTIONS["SUPER"] = "super";
  ALIGN_V_OPTIONS["TEXT_TOP"] = "text-top";
  ALIGN_V_OPTIONS["TEXT_BOTTOM"] = "text-bottom";
  ALIGN_V_OPTIONS["MIDDLE"] = "middle";
  ALIGN_V_OPTIONS["TOP"] = "top";
  ALIGN_V_OPTIONS["BOTTOM"] = "bottom";
  return ALIGN_V_OPTIONS;
}({});
exports.ALIGN_V_OPTIONS = ALIGN_V_OPTIONS;
let WHITE_SPACE = /*#__PURE__*/function (WHITE_SPACE) {
  WHITE_SPACE["NORMAL"] = "normal";
  WHITE_SPACE["NOWRAP"] = "nowrap";
  WHITE_SPACE["PRE"] = "pre";
  WHITE_SPACE["PRE_LINE"] = "pre-line";
  WHITE_SPACE["PRE_WRAP"] = "pre-wrap";
  return WHITE_SPACE;
}({});
exports.WHITE_SPACE = WHITE_SPACE;